import { CalendarDaysIcon } from "@heroicons/react/24/outline";

import { HistoryCardTextInfoItem } from "shared/ui/activity-log/cards-v2/base";
import { safeGetDate } from "shared/lib/helpers";
import { DATE_FORMAT_SHORT } from "shared/lib/constants/time";
import { PropsWithClassNameI } from "shared/lib/interfaces/ui";

interface HistoryCardEventDateBasePropsI extends PropsWithClassNameI {
  isBold?: boolean;
  date?: string;
}

interface HistoryCardEventDatePropsI extends HistoryCardEventDateBasePropsI {
  title: string;
}

const HistoryCardEventDate = ({
  className,
  date,
  title,
  isBold,
}: HistoryCardEventDatePropsI) => (
  <HistoryCardTextInfoItem
    icon={<CalendarDaysIcon className="h-6 w-6" />}
    subtitle={title}
    infoClassName={className}
    info={[
      {
        isBold,
        title: date ? safeGetDate(date, DATE_FORMAT_SHORT) : "N/A",
      },
    ]}
  />
);

export const HistoryCardCallbackBookedInfo = ({
  date,
}: HistoryCardEventDateBasePropsI) => (
  <HistoryCardEventDate date={date} title="Callback date" />
);

export const HistoryCardBookedMeetingInfo = ({
  isBold,
  date,
}: HistoryCardEventDateBasePropsI) => (
  <HistoryCardEventDate isBold={isBold} date={date} title="Meeting date" />
);

export const HistoryCardBookedMeetingOriginalInfo = ({
  isBold,
  date,
}: HistoryCardEventDateBasePropsI) => (
  <HistoryCardEventDate
    isBold={isBold}
    date={date}
    className="line-through"
    title="Original meeting date"
  />
);
